module.exports = __webpack_public_path__ + "img/drug_enforcement-blurred.cc822df1.jpg";